import styled from 'styled-components';

export const ActiveStatus = styled.div`
   width: 98px;
    height: 42px;
    border-radius: 16px;
    border: 1px solid #70AC17;
    background: rgba(194, 225, 163, 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 9px 30px 9px 30px;

    text-align: center;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`